var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7142 3.19046C13.2402 2.66447 13.2402 1.81168 12.7142 1.28569C12.1882 0.759709 11.3354 0.75971 10.8094 1.28569L6.99992 5.09522L3.1904 1.28569C2.66441 0.759709 1.81162 0.759708 1.28563 1.28569C0.759648 1.81168 0.759649 2.66447 1.28563 3.19046L5.09516 6.99998L1.28563 10.8095C0.759647 11.3355 0.759647 12.1883 1.28563 12.7143C1.81162 13.2403 2.66441 13.2402 3.1904 12.7143L6.99992 8.90474L10.8094 12.7143C11.3354 13.2403 12.1882 13.2403 12.7142 12.7143C13.2402 12.1883 13.2402 11.3355 12.7142 10.8095L8.90468 6.99998L12.7142 3.19046Z",
    fill: "#6D6D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.453615cfdc3411271af41d56f9239a54.svg";
export { ForwardRef as ReactComponent };